@let view = workflowService.currentView();
@let document = currentDocument();
<div class="grid h-full min-h-0 w-full grid-cols-2 gap-4">
  <ct-extraction-document-preview
    #documentPreview
    class="min-h-0"
    [isConsolidation]="view.type === AppViewType.CONSOLIDATION"
    [isPreviewListExpandedInitially]="
      view.type === AppViewType.CONSOLIDATION || view.type === AppViewType.ERFASSUNG_BEHANDLER
    "
    [isTableExtraction]="isExtractionPageWithTableSection()"
    [documents]="documents()"
    [ensureSingleOverlay]="isErfasseBehandlerView(view)"
    [singleOpenedDocument]="document"
    [enableOverlay]="enableOverlay()"
    (documentSelected)="selectedDocumentId.set($event)" />
  <div class="flex min-h-0 flex-col gap-4 overflow-auto">
    @if (proof301OverviewService.isNotEmpty()) {
      <ct-extraction-existing-301-warning
        [proof301Overview]="proof301OverviewService.overview.value()!" />
    }

    @switch (view.type) {
      @case (AppViewType.AUFTRAG_ASSIGNMENT) {
        <ct-extraction-auftrag-assignment
          [extractionPage]="currentFieldService.extractionPage!"
          [(currentActiveField)]="currentFieldService.currentActiveField"
          [(currentActiveSection)]="currentFieldService.currentActiveSection"
          [currentActiveFieldModel]="currentFieldService.currentActiveFieldModel"
          [areAllSectionsValid]="currentFieldService.areAllSectionsValid"
          (changeSectionStatus)="
            currentFieldService.updateSectionStatus($event.section, $event.status)
          "
          (continue)="onContinue()" />
      }
      @case (AppViewType.ERFASSUNG_BEHANDLER) {
        <ct-extraction-erfassung-behandler
          [documents]="documents()"
          [selectedDocumentId]="selectedDocumentId()"
          (continue)="onContinue()"
          (enableOverlay)="enableOverlay.set($event)"
          (selectedPageChanged)="documentPreview.setSelectedPageId($event)" />
      }
      @case (AppViewType.EXTRACTION) {
        <ct-extraction-page
          [currentDocument]="document!"
          [extractionPage]="currentFieldService.extractionPage!"
          [(currentActiveField)]="currentFieldService.currentActiveField"
          [(currentActiveSection)]="currentFieldService.currentActiveSection"
          [currentActiveFieldModel]="currentFieldService.currentActiveFieldModel"
          [areAllSectionsValid]="currentFieldService.areAllSectionsValid"
          [hasMultipleTableSections]="hasMultipleTableSections()"
          (focusNextSection)="currentFieldService.focusNextSection()"
          (changeSectionStatus)="
            currentFieldService.updateSectionStatus($event.section, $event.status)
          "
          (continue)="onContinue()"
          class="min-h-0" />
      }
      @case (AppViewType.TABLE_ROW_CLASSIFICATION) {
        <ct-extraction-row-classification-page
          [currentDocument]="document!"
          [tableModel]="view.tableModel"
          (continue)="onContinue()" />
      }
      @case (AppViewType.CONSOLIDATION) {
        <ct-extraction-consolidation
          [splitDocumentId]="view.splitDocumentId"
          [splitEntityIndex]="view.splitEntityIndex"
          [extractionPage]="currentFieldService.extractionPage!"
          [(currentActiveField)]="currentFieldService.currentActiveField"
          [(currentActiveSection)]="currentFieldService.currentActiveSection"
          [currentActiveFieldModel]="currentFieldService.currentActiveFieldModel"
          [areAllSectionsValid]="currentFieldService.areAllSectionsValid"
          (focusNextSection)="currentFieldService.focusNextSection()"
          (focusNextField)="currentFieldService.focusNextField()"
          (changeSectionStatus)="
            currentFieldService.updateSectionStatus($event.section, $event.status)
          "
          (continue)="onContinue()"
          class="h-full" />
      }
      @default {
        Unknown view type.
      }
    }
  </div>
</div>

<shared-ui-dev-tools-card />
